module.exports = __webpack_public_path__ + "media/interview4.081c802b.mp3";